<template>
  <div class="login-container">
    <!--背图片 -->
    <div class="background-overlay"></div>
    
    <!-- 登录面板 -->
    <div class="login-card">
      <!-- Logo区域 -->
      <div class="logo-section">
        <img src="../assets/Yier.png" alt="Logo" class="logo">
        <h2 class="title">熊熊数据浏览器</h2>
      </div>
      
      <!-- 登录表单 -->
      <el-form 
        ref="loginForm" 
        :model="loginForm" 
        :rules="loginRules" 
        class="login-form"
        @keyup.enter="handleLogin"
      >
        <!-- 用户名输入 -->
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            prefix-icon="User"
            size="large"
            clearable
          />
        </el-form-item>
        
        <!--密输入 -->
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="Lock"
            size="large"
            show-password
            clearable
          />
        </el-form-item>
        
        <!--记密码 -->
        <div class="remember-section">
          <el-checkbox v-model="loginForm.remember">记住密码</el-checkbox>
        </div>
        
        <!-- 登录按钮 -->
        <el-form-item>
          <el-button
            type="primary"
            size="large"
            class="login-button"
            :loading="loading"
            @click="handleLogin"
          >
            {{ loading ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
      
      <!--底信息 -->
      <div class="footer">
        <p>© 金熊熊and孙一二2026</p>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'UserLogin',
  data() {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: '',
        remember: false
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          
          // 调用后端登录 API
          request.post('/auth/login', {
            username: this.loginForm.username,
            password: this.loginForm.password
          })
          .then(response => {
            const res = response.data
            
            if (res.code === 200) {
              // 登录成功
              this.$message.success('登录成功')
              
              // 保存 token 和用户信息
              localStorage.setItem('token', res.data.token)
              localStorage.setItem('isLoggedIn', 'true')
              localStorage.setItem('username', res.data.user.username)
              localStorage.setItem('userInfo', JSON.stringify(res.data.user))
              
              if (this.loginForm.remember) {
                localStorage.setItem('rememberUser', JSON.stringify({
                  username: this.loginForm.username,
                  remember: true
                }))
              }
              
              // 跳转到主页面（班级列表）
              this.$router.push('/main')
            } else {
              // 登录失败
              this.$message.error(res.message || '用户名或密码错误')
            }
          })
          .catch(error => {
            console.error('登录失败:', error)
            this.$message.error('服务器异常，请稍后重试')
          })
          .finally(() => {
            this.loading = false
          })
        }
      })
    }
  },
  mounted() {
    //是否记住用户
    const rememberUser = localStorage.getItem('rememberUser')
    if (rememberUser) {
      const user = JSON.parse(rememberUser)
      this.loginForm.username = user.username
      this.loginForm.remember = user.remember
    }
  }
}
</script>

<style scoped>
.login-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('../assets/background.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(2px);
}

.login-card {
  position: relative;
  width: 400px;
  padding: 40px 30px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(15px); /* 增加模糊度 */
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.3); /* 边框更明显 */
  z-index: 10;
}

.logo-section {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
  border-radius: 50%;
  object-fit: cover;
}

.title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.login-form {
  margin-top: 20px;
}

.remember-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.login-button {
  width: 100%;
  height: 45px;
  font-size: 16px;
  font-weight: 500;
}

.footer {
  text-align: center;
  margin-top: 25px;
}

.footer p {
  font-size: 12px;
  color: #999;
  margin: 0;
}

/*响应式设计 */
@media (max-width: 480px) {
  .login-card {
    width: 90%;
    padding: 30px 20px;
  }
  
  .title {
    font-size: 20px;
  }
  
  .logo {
    width: 60px;
    height: 60px;
  }
}
</style>